import React, {useEffect} from 'react';
import config from '../config';
import MintControl from '../components/mint-control';
import solanaChefCoinImage from '../media/mk.jpeg'; // do not remove
import {gPageView} from '../google-analytics';
import {CrossmintPayButton} from '@crossmint/client-sdk-react-ui';
import * as anchor from '@project-serum/anchor';
import mkChefImage from '../media/cm-chef-image.jpg';
import AlphaVerifi from "../media/partners/alpha-verifi-logo.jpeg";
import mkFrame from "../media/mk-frame.png";

const ogChefsCandyMachineId = new anchor.web3.PublicKey(
  config.OG_CHEFS_CANDY_MACHINE_ID
);

function MintPage() {
  useEffect(() => {
    gPageView('mint');
  },);
  return (
    <div id="mint-page" className="panel md:flex-row">
        <div className="relative mt-16">
            <div className="z-10 absolute top-0 -m-16">
                <img className="" src={mkFrame} />
            </div>
            <img className="w-60" src={mkChefImage}/>
        </div>
        <div className="p-16 md:mt-16">
              {
                config.IS_MINT_ACTIVE ?
                  <>
                    <MintControl
                      candyMachineId={ogChefsCandyMachineId}
                      treasury={config.TREASURY_ADDRESS}
                      rpcHost={config.SOLANA_RPC_HOST}
                      txTimeout={config.TRANSACTION_TIMEOUT}
                    />
                    <div className="">
                      <p className="text-center text-xl">or</p>
                      <CrossmintPayButton
                        className="mx-auto"
                        collectionTitle="metaKitchen OG Chefs"
                        collectionDescription="metaKitchen bridges the digital and physical world of food into a web3 ecosystem built for chefs, home cooks and gamers. 3000 OG Chefs - The founders of metaKitchen will give access to the mK game-fi ecosystem and grant you a role in the mK Syndicate."
                        collectionPhoto="https://metakitchen.io/carousel/carousel-6.png"
                        clientId="9d2ca1c1-ffdc-4b03-a57c-436e38810fbd"
                        mintConfig={{"type":"candy-machine"}}
                      />
                    </div>
                  </>
                  :
                  <div>Minting is not currently active. Please refer to our discord channel for more information.</div>
              }
            <img src={solanaChefCoinImage} style={{display: 'none'}}/>
            <div className="mx-auto w-32 text-center text-brand-text text-2xl cursor-pointer hover:font-bold bg-zinc-600 rounded-lg mt-2">
                <a className="pl-2" href="https://www.alpha-verifi.com/metakitchen">
                    DOXXED&nbsp;<img className="mx-auto w-16 p-1 rounded-lg" alt="Alpha Verifi link" src={AlphaVerifi} />
                </a>
            </div>
        </div>
    </div>
  );
}

export default MintPage;
